import React, { Component, PropTypes } from 'react';
import { connect } from 'react-redux';
import { getUniqueBodyStyles } from '../../redux/selectors/models'
import { getTermFromState } from '../../redux/selectors/i18n'
import Title from '../../components/Title'
import VehicleGrid from './VehicleGrid'
import BodyStyleFilter from './BodyStyleFilter'

/**
 * The Model Line Select View is the "starting point" For a fresh start on the Payment Estimator
 * Users come to this view, select the body style of vehicle they want and are then
 * directed to the Trim Select view
 */
class ModelLineSelect extends Component {
  static propTypes = {
    bodyStyles: PropTypes.array.isRequired,
    title: PropTypes.string.isRequired,
    description: PropTypes.string.isRequired,
    brand: PropTypes.string.isRequired,
  }
  static renderBodyStyles(bodyStyles) {
    return (bodyStyles) ? <VehicleGrid bodyStyles={bodyStyles} /> : undefined;
  }
  constructor() {
    super();
    this.renderBodyStylesFilter = this.renderBodyStylesFilter.bind(this);
    this.renderBodyStyles = ModelLineSelect.renderBodyStyles;
  }

  renderBodyStylesFilter(bodyStyles) {
    // Might want to make this configurable instead of checking current brand
    return this.props.brand === 'ni' ? <BodyStyleFilter bodyStyles={bodyStyles} /> : undefined;
  }

  render() {
    const { title, description, bodyStyles } = this.props;

    return (
      <div className="model-line-container small-10 small-centered">
        <Title title={title} description={description} />
        <div className="row">
          <div className="columns">

            {this.renderBodyStylesFilter(bodyStyles)}
            {this.renderBodyStyles(bodyStyles)}
          </div>
        </div>
      </div>
    );
  }
}

const mapStateToProps = state => ({
  bodyStyles: getUniqueBodyStyles(state),
  title: getTermFromState(state, 'titlePanel.title'),
  description: getTermFromState(state, 'titlePanel.description'),
  brand: state.environment.BRAND_CHANNEL
});


export default connect(mapStateToProps)(ModelLineSelect);



/** WEBPACK FOOTER **
 ** ./src/pages/ModelLineSelect/index.js
 **/